import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';

const ContactSection = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    return (
        <section className="w-full bg-[#F0F0F0] overflow-hidden select-none">
            <div className="flex flex-col md:flex-row items-stretch max-w-[1440px] w-full mx-auto">

                <div className="w-full lg:w-full max-w-[585px] min-h-[350px] md:min-h-auto relative shrink-0">
                    <img
                        src="/assets/transforming/img3.png"
                        alt="Future Visual"
                        className="absolute inset-0 w-full h-full object-cover"
                    />
                </div>

                <div className="w-full md:flex-1 bg-[#F0F0F0] py-16 px-6 sm:px-12 lg:px-20 flex flex-col justify-center">
                    <div className="max-w-[720px] w-full mx-auto">

                        <h2 className="text-[#01386A] font-sora font-[600] text-[20px] lg:text-[30px] leading-[1.2] tracking-tight mb-12">
                            Let's Build the Future Together
                        </h2>

                        <form onSubmit={handleSubmit} className="w-full flex flex-col gap-8">

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-8">
                                <div className="flex flex-col gap-2">
                                    <label className="text-[#01386A] font-outfit text-[14px] font-medium">
                                        First Name <span className="text-[#ED7A3A]">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        placeholder="Enter your First name"
                                        required
                                        className="w-full bg-transparent border-b border-[#C1C7D0] focus:border-[#4D71EF] py-2 text-[15px] font-outfit text-[#0A2540] placeholder-[#A2AAB5] outline-none transition-colors"
                                    />
                                </div>

                                <div className="flex flex-col gap-2">
                                    <label className="text-[#01386A] font-outfit text-[14px] font-medium">
                                        Last Name <span className="text-[#ED7A3A]">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        placeholder="Enter Your Last name"
                                        required
                                        className="w-full bg-transparent border-b border-[#C1C7D0] focus:border-[#4D71EF] py-2 text-[15px] font-outfit text-[#0A2540] placeholder-[#A2AAB5] outline-none transition-colors"
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-8">
                                <div className="flex flex-col gap-2">
                                    <label className="text-[#01386A] font-outfit text-[14px] font-medium">
                                        Email <span className="text-[#ED7A3A]">*</span>
                                    </label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="Enter Your Last name"
                                        required
                                        className="w-full bg-transparent border-b border-[#C1C7D0] focus:border-[#4D71EF] py-2 text-[15px] font-outfit text-[#0A2540] placeholder-[#A2AAB5] outline-none transition-colors"
                                    />
                                </div>

                                <div className="flex flex-col gap-2">
                                    <label className="text-[#01386A] font-outfit text-[14px] font-medium">
                                        Phone <span className="text-[#ED7A3A]">*</span>
                                    </label>
                                    <input
                                        type="tel"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        placeholder="Enter Your Last name"
                                        required
                                        className="w-full bg-transparent border-b border-[#C1C7D0] focus:border-[#4D71EF] py-2 text-[15px] font-outfit text-[#0A2540] placeholder-[#A2AAB5] outline-none transition-colors"
                                    />
                                </div>
                            </div>

                            <div className="flex flex-col gap-2 w-full">
                                <label className="text-[#01386A] font-outfit text-[14px] font-medium">
                                    Your Message <span className="text-[#ED7A3A]">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    placeholder="Enter Your Last name"
                                    required
                                    className="w-full bg-transparent border-b border-[#C1C7D0] focus:border-[#4D71EF] py-2 text-[15px] font-outfit text-[#0A2540] placeholder-[#A2AAB5] outline-none transition-colors"
                                />
                            </div>

                            <div className="pt-4">
                                <button
                                    type="submit"
                                    className="group border border-[#ED7A3A] bg-transparent hover:bg-[#ED7A3A] text-[#ED7A3A] hover:text-white px-8 py-3 font-sora font-medium text-[15px] transition-all duration-300 rounded-none flex items-center gap-4 cursor-pointer"
                                >
                                    <span>Submit</span>
                                    <ArrowRight size={16} className="text-[#ED7A3A] group-hover:text-white transition-colors" />
                                </button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactSection;